module.exports = __webpack_public_path__ + "static/unity_top_back-08d418b15839af26179ad1c694d2a674.png";